import axios from "../plugins/axios.plugin";

class RevenueWalletService {
  baseServicePath = "/api/revenue/wallet";

  getAllRevenueWallet(page) {
    return axios.get(`${this.baseServicePath}/index?page=${page}&properties=1`);
  }

  getAllRevenueWalletsNoPagination(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  showARevenueWallet(id) {
    return axios.get(`${this.baseServicePath}/show?id=${id}`);
  }

  searchRevenueWallet(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  filterRevenueWallet(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  editRevenueWallet(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }

  storeRevenueWallet(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }
}
export const revenueWalletService = new RevenueWalletService();
